import { UserPermission } from "./user-permission";
import { UserRoleTypes } from "./user-role-types";

export class UserRole {
  private userRoleKey: string;
  private name: string;
  private userPermissionList: UserPermission[];
  private userRoleType: string;

  setUserRoleKey(value: string): void {
    this.userRoleKey = value;
  }

  getUserRoleKey(): string {
    return this.userRoleKey;
  }

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }

  setUserPermissionList(value: UserPermission[]): void {
    this.userPermissionList = value;
  }

  getUserPermissionList(): UserPermission[] {
    return this.userPermissionList;
  }

  setUserRoleType(value: string): void {
    this.userRoleType = value;
  }

  getUserRoleType(): string {
    return this.userRoleType;
  }

  isAdministratorRole(): boolean {
    return (
      this.userRoleType === UserRoleTypes.SuperAdministrator ||
      this.userRoleType === UserRoleTypes.TenantManager ||
      this.userRoleType === UserRoleTypes.ExternalManager
    );
  }

  isManagerRole(): boolean {
    return this.userRoleType === UserRoleTypes.Manager;
  }
  isExternalManagerRole(): boolean {
    return this.userRoleType === UserRoleTypes.ExternalManager;
  }
  isCompanyManagerRole(): boolean {
    return (
      this.userRoleType == UserRoleTypes.CompanyManager || this.userRoleType == UserRoleTypes.ExternalManager || this.userRoleType == UserRoleTypes.Manager
    );
  }

  isRoleWithAdminPrivileges(): boolean {
    return this.isAdministratorRole() || this.isManagerRole();
  }
}
